import dom from './util/dom';
import register from '../register';

register( 'reviews-carousel', function() {

  // review quotation divs
  let reviewElems = Array.prototype.slice.call(
    document.querySelectorAll('.press-quotes .review')
  );

  // press logos
  let logoElems = Array.prototype.slice.call(
    document.querySelectorAll('.press-logos__logo')
  );

  // left/right arrows
  let arrows = Array.prototype.slice.call(
    document.querySelectorAll('.press-quotes .icon')
  );

  let currentIndex = 0;

  // initialize the review divs with numeric indexes
  reviewElems.forEach( function( elem, index ) {
    elem.dataset.index = index;
  });

  // initialize the press logos with numeric indexes
  logoElems.forEach( function( elem, index ) {
    elem.dataset.index = index;
    elem.addEventListener( 'click', function() {
      fadeOutIn( currentIndex, currentIndex = index );
    });
  });

  // bind listeners for left/right arrows
  arrows.forEach( function( arrow ) {
    arrow.addEventListener( 'click', changeReview );
  });

  function changeReview( ev ) {
    let target = ev.currentTarget;
    let direction = parseInt( target.dataset.direction );
    let oldIndex = currentIndex;

    currentIndex += direction;

    if ( currentIndex < 0 ) {
      currentIndex = reviewElems.length - 1;
    } else if ( currentIndex >= reviewElems.length ) {
      currentIndex = 0;
    }

    fadeOutIn( oldIndex, currentIndex );
  }

  function fadeOutIn( outIndex, inIndex ) {
    dom.removeClass( reviewElems[ outIndex ], 'visible' );
    dom.addClass( reviewElems[ inIndex ], 'visible' );
    dom.removeClass( logoElems[ outIndex ], 'active' );
    dom.addClass( logoElems[ inIndex ], 'active' );
  }

});

export default undefined;
